import React from "react";
import { Row, Col } from "react-flexbox-grid";
import Toogle from "../toggle";
import { DescriptionField, IconButton } from "components/support";

const IntegrationsList = ({ integrations, presenter, handleEdit }) => {
  const handleToggle = integration => {
    const updatedIntegration = { ...integration, enabled: !integration.enabled }
    presenter.onSaveEnabled(updatedIntegration)
  }

  return integrations.map((integration, index) => (
    <Row key={index}>
      <Col xs={10}>
          <DescriptionField value={integration.name} />
        </Col>
        <Col xs={1}>
          <Toogle
            data={integration}
            onChangeEnabled={() => handleToggle(integration)}
          />
        </Col>
        <Col xs={1}>
          <IconButton icon="mode_edit" onClick={() => handleEdit(integration)} />
        </Col>
    </Row>
  ));
}


export default IntegrationsList;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/order_integrations/integrations-list/IntegrationsList.jsx